<template>
  <div class="moves" ref="movebox">
    <div class="row p-0 m-0">
      <template v-for="(move, movec) in list">
        <div class="col-2 py-1 text-center move-row" v-bind:key="`${(movec / 2) + 1}_row`" v-if="movec % 2 === 0" @click.prevent="selectMove(movec)">
          {{ (movec / 2) + 1 }}
        </div>
        <div class="col-5 py-1 move" v-bind:key="movec" v-bind:class="{ 'current': movec === moveIndex }" @click.prevent="selectMove(movec)">
          {{ move }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimeLeft',
  props: {
    list: Array,
    moveIndex: Number,
  },
  watch: {
    list() {
      setTimeout(() => {
        if (typeof this.$refs.movebox !== 'undefined') {
          this.$refs.movebox.scrollTop = this.$refs.movebox.scrollHeight;
        }
      }, 0);
    },
  },
  methods: {
    selectMove(index) {
      this.$root.$emit('selectMove', index);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .moves {
    height: 200px;
    overflow-x: hidden;
    overflow-y: hidden;
    overflow: scroll;
    ::-webkit-scrollbar {
        display: none;
    }
  }
  .move-row {
    background: rgba(255,255,255,0.1);
  }
  .move {
    cursor: pointer;
  }
  .move:hover {
    background: #3692e7;
    color: #fff;
  }
  .current {
    background: #293a49; // rgba(0,0,0,0.1);
    font-weight: bold;
    color: #fff;
  }
</style>
